import { Radio } from "@mantine/core";
import { TStaffSurveyJob } from "../../../types";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
  puestos: TStaffSurveyJob[];
  setIsLeader: (isLeader: boolean) => void;
  useDefaultJobs: boolean;
};

const Component = ({ form, puestos, setIsLeader, useDefaultJobs }: Props) => {
  const { t } = useTranslation();

  return (
    <RadioSurvey
      label="¿Cuál es tu puesto?"
      {...form.getInputProps("IL_006_puestoDeTrabajo")}
      orientation="vertical"
    >
      {useDefaultJobs ? (
        <>
          <Radio
            label={"Puesto con personal a cargo"}
            value="default_leader"
            onClick={() => setIsLeader(true)}
          />
          <Radio
            label={"Puesto sin personal a cargo"}
            value="default_worker"
            onClick={() => setIsLeader(false)}
          />
        </>
      ) : (
        puestos?.map((puesto) => (
          <Radio
            label={puesto.description}
            value={puesto.id.toString()}
            key={puesto.id}
            onClick={() => setIsLeader(puesto.is_leader)}
          />
        ))
      )}
    </RadioSurvey>
  );
};

export default Component;
